import { render, staticRenderFns } from "./addparent.vue?vue&type=template&id=28fe3283&"
import script from "./addparent.vue?vue&type=script&lang=js&"
export * from "./addparent.vue?vue&type=script&lang=js&"
import style0 from "./addparent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports